// /* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './AudioCaptions.module.scss';
import { useLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';

const AudioCaptions = ({ className }) => {
  const [
    {
      settings: { accessibility }
    }
  ] = useLwtStore();
  const { currentCaption } = useSelector(state => state.student);
  const closedCaptionSize = accessibility.closedCaptionsSettings.closedCaptionSize;

  if (!currentCaption) return null;

  return (
    <div className={`${styles.captionsContainer} ${className}`}>
      <p className={styles.captionTrack} style={{ fontSize: closedCaptionSize }}>
        {currentCaption}
      </p>
    </div>
  );
};

AudioCaptions.propTypes = {
  className: PropTypes.string
};

export default AudioCaptions;
